import { createPortal } from 'react-dom'
import SafeImage from '../SafeImage'
import './index.scss'

export default function LoadingScreen({ open = false, logoSrc = '/logo.png', logoAlt = '', statusLabel = 'Đang tải dữ liệu', solid = false }) {
  if (!open || typeof document === 'undefined') {
    return null
  }

  return createPortal(
    <div className={`LoadingScreen${solid ? ' LoadingScreen_solid' : ''}`} aria-live="polite" aria-busy="true">
      <div className="LoadingScreen_overlay" />

      <div className="LoadingScreen_dialog" role="status" aria-label={statusLabel}>
        <div className="LoadingScreen_content">
          <div className="LoadingScreen_spinnerWrap">
            <div className="LoadingScreen_spinner" />
            <SafeImage className="LoadingScreen_logo" src={logoSrc} alt={logoAlt} />
          </div>
        </div>
      </div>
    </div>,
    document.body
  )
}
